import SearchInput from 'shared/Inputs/SearchInput'
import { useRecoilState } from 'recoil'
import projectTechnologiesTableAtom from '../ProjectTechnologiesTable/projectTechnologiesTable.atom'

const ProjectTechnologiesFilters = () => {
  const [state, setState] = useRecoilState(projectTechnologiesTableAtom)

  const handleChange = (value: any, name: string) => {
    setState((prev) => ({ ...prev, filters: { ...prev.filters, [name]: value } }))
  }

  return (
    <div className='inline-flex-gap' style={{ gap: '8px' }}>
      <SearchInput
        value={state.filters.search}
        name='search'
        onChange={handleChange}
        required={false}
        placeholder='Поиск'
        autofocus={true}
      />
    </div>
  )
}

export default ProjectTechnologiesFilters
